import styled from "@emotion/styled";
import { SpeakingSlotRegistrationCandidateDto } from "api/planning/api";
import { DateTime } from "luxon";
import { Divider, Icon } from "semantic-ui-react";
import { BookedSlotTimeIndicator } from "./BookedSlotTimeIndicator";

type Props = {
  booking?: SpeakingSlotRegistrationCandidateDto;
  startTime: string;
  endTime: string;
};

export const formatDateOfBirth = (datetime?: string) => {
  if (!datetime) {
    return '';
  }

  return DateTime.fromISO(datetime, { setZone: true }).toFormat('dd-MM-yyyy');
};

export const SpeakingSlotRegistrationBookingPopup = ({ booking, startTime, endTime }: Props) => {
  return (
    <>
      <S.PopupLine>
        <Icon name="graduation cap" /> <b>{booking?.firstName} {booking?.surname}</b>
        <S.IconGroup>
          {booking?.isMinor && <Icon name="child" />}
          {booking?.isYoungAdult && <Icon name="umbrella" />}
          {booking?.hasAccessArrangements && <Icon name="universal access" />}
        </S.IconGroup>
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="home" /> {booking?.postCode} {booking?.city}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="birthday cake" /> {formatDateOfBirth(booking?.dateOfBirth)}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="phone square" /> {booking?.phoneNumber}
      </S.PopupLine>
      <Divider />
      <BookedSlotTimeIndicator startTime={startTime} endTime={endTime} />
    </>
  );
};

const S = {
  PopupLine: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-size: 0.85em;
    min-width: 250px;
  `,
  IconGroup: styled.div`
    margin-left: auto;
    display: flex;
    gap: 0.25em;
  `,
};